import React from 'react';

import type { IconProps } from '../../icon-types';
import { IconBase } from '../../IconBase';

export const WifiOffIcon = React.forwardRef<SVGSVGElement, IconProps>(function WifiOffIcon(props, ref) {
    return (
        <IconBase
            ref={ref}
            viewBox="0 0 16 16"
            {...props}
        >
            <path
                fill="currentColor"
                d="M1.22 7.07.03 5.88q.32-.3.66-.57.34-.28.7-.53L.5 4.15l.95-1.35 13.1 9.17-.95 1.36-5.22-3.65-.19-.01H8q-.85 0-1.62.3t-1.41.88L3.8 9.67a6 6 0 0 1 1.18-.88 6 6 0 0 1 1.34-.56l-1-.7a7 7 0 0 0-1.18.61 7 7 0 0 0-1.04.83L1.93 7.78a9 9 0 0 1 1.82-1.35l-.9-.63q-.43.28-.84.6-.41.3-.8.67m5.85 5.87a1.3 1.3 0 0 1-.4-.94q0-.55.4-.94.39-.4.94-.4t.94.4.4.94-.4.94a1.3 1.3 0 0 1-.94.4q-.55 0-.94-.4m-.38-8.52-1.86-1.3q.78-.24 1.57-.35A12 12 0 0 1 8 2.68q2.23 0 4.3.82a11 11 0 0 1 3.67 2.4l-1.19 1.18a10 10 0 0 0-3.11-2.03A10 10 0 0 0 8 4.34l-.66.01zm6.34 4.43L7.98 5.33q1.72 0 3.3.63a9 9 0 0 1 2.8 1.8z"
            />
        </IconBase>
    );
});
